import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '@/hooks/useTheme';

export default function AdminBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDark } = useTheme();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const userType = localStorage.getItem('userType');
    const token = localStorage.getItem('token');
    if (token && userType === 'admin') {
      setIsAdmin(true);
    }
  }, []);

  if (!isAdmin || location.pathname.startsWith('/admin') || location.pathname.startsWith('/vendor') || location.pathname === '/login') return null;

  return (
    <div className={`w-full px-3 py-2 flex items-center justify-between gap-3 ${
      isDark ? 'bg-gold/20 border-b border-gold/30' : 'bg-gold/15 border-b border-gold/25'
    } backdrop-blur-md`}>
      <div className="flex items-center gap-2 min-w-0">
        <div className="w-5 h-5 rounded-md bg-gold flex items-center justify-center flex-shrink-0">
          <i className="ri-shield-check-line text-white text-[10px]"></i>
        </div>
        <span className={`text-[11px] font-semibold truncate ${isDark ? 'text-gold' : 'text-gold-dark'}`}>
          Admin View
        </span>
      </div>
      <button
        onClick={() => navigate('/admin')}
        className="px-2.5 py-1 rounded-lg text-[10px] font-bold bg-gold text-white hover:bg-gold-dark transition-all cursor-pointer whitespace-nowrap flex items-center gap-1 flex-shrink-0"
      >
        <i className="ri-dashboard-line text-xs"></i>
        Admin Panel
      </button>
    </div>
  );
}